// error.ts
var DialogCancledDueToRouteChange = Symbol("Dialog cancled due to route change");
export {
  DialogCancledDueToRouteChange
};
